import { actions, mutations } from "@/constants/state";
import { get } from "@/services/horeca-location-service";

export default {
  [actions.HORECA_LOCATIONS_FETCH_ACTION]: async ({ commit }) => {
    const { data } = await get();
    commit(mutations.HORECA_LOCATIONS_FETCH_MUTATION, data);
  },
};
